import { render, staticRenderFns } from "./SupplierAnalisis.vue?vue&type=template&id=332560d2&scoped=true&"
import script from "./SupplierAnalisis.vue?vue&type=script&lang=js&"
export * from "./SupplierAnalisis.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAnalisis.vue?vue&type=style&index=0&id=332560d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332560d2",
  null
  
)

export default component.exports